var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"alt":"lock","src":require("public/img/icons/icon-secure.svg")}}),_vm._v(" "),_c('span',[_vm._v("Verifying Device and User")])])
}]

export { render, staticRenderFns }